import { render, staticRenderFns } from "./NewsNew.vue?vue&type=template&id=3a91cbf0&scoped=true&"
import script from "./NewsNew.vue?vue&type=script&lang=js&"
export * from "./NewsNew.vue?vue&type=script&lang=js&"
import style0 from "./NewsNew.vue?vue&type=style&index=0&id=3a91cbf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91cbf0",
  null
  
)

export default component.exports